<script lang="ts">
	const { text }: { text?: string } = $props();
</script>

<div class="bg-base-100 text-accent/50 p-3 uppercase">
	{text ?? 'Wird geladen'} <span class="animate-bounce">...</span>
</div>
